/* The Most Wanted Custom Silver — homepage behaviour.
   Hero slider + FAQ accordion. No dependencies. */
(function () {
  /* ---- Hero slider: crossfade, auto-advance ---- */
  var root = document.querySelector('[data-tmws-hero]');
  var slides = [].slice.call(document.querySelectorAll('[data-slide]'));
  var dots = [].slice.call(document.querySelectorAll('[data-dot]'));
  var interval = root ? (parseInt(root.getAttribute('data-interval'), 10) || 6500) : 6500;
  var i = 0, timer;

  function show(k) {
    i = (k + slides.length) % slides.length;
    slides.forEach(function (s, x) {
      s.style.opacity = x === i ? '1' : '0';
      s.style.pointerEvents = x === i ? 'auto' : 'none';
    });
    dots.forEach(function (d, x) {
      d.style.background = x === i ? '#E8462D' : 'rgba(255,255,255,.38)';
    });
  }
  function start() { stop(); if (slides.length > 1) { timer = setInterval(function () { show(i + 1); }, interval); } }
  function stop() { if (timer) clearInterval(timer); }

  document.querySelectorAll('[data-hero]').forEach(function (b) {
    b.addEventListener('click', function () {
      var v = b.getAttribute('data-hero');
      show(v === 'prev' ? i - 1 : v === 'next' ? i + 1 : parseInt(v, 10));
      start();
    });
  });
  dots.forEach(function (d) {
    d.addEventListener('click', function () { show(parseInt(d.getAttribute('data-dot'), 10)); start(); });
  });
  if (slides.length) { show(0); start(); }

  /* ---- FAQ accordion: one panel open at a time ---- */
  var open = -1;
  document.querySelectorAll('[data-faq-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var k = parseInt(btn.getAttribute('data-faq-toggle'), 10);
      open = open === k ? -1 : k;
      document.querySelectorAll('[data-faq-answer]').forEach(function (a) {
        a.style.display = parseInt(a.getAttribute('data-faq-answer'), 10) === open ? 'block' : 'none';
      });
      document.querySelectorAll('[data-faq-icon]').forEach(function (s) {
        s.style.transform = parseInt(s.getAttribute('data-faq-icon'), 10) === open ? 'rotate(45deg)' : 'rotate(0deg)';
      });
    });
  });

  /* ---- Language switcher: submit on change ---- */
  document.querySelectorAll('[data-tmws-lang]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var form = sel.closest('form');
      if (!form) return;
      /* Currency follows the market, and the market follows the country, so the
         language choice carries its matching country along with it. */
      var raw = sel.getAttribute('data-country-map') || '';
      var country = null;
      raw.split(',').forEach(function (pair) {
        var kv = pair.split(':');
        if (kv.length === 2 && kv[0].trim() === sel.value) country = kv[1].trim();
      });
      var hidden = form.querySelector('[data-tmws-country]');
      if (hidden) {
        if (country) hidden.value = country;
        else hidden.parentNode.removeChild(hidden);   /* no mapping: change language only */
      }
      form.submit();
    });
  });

  /* ---- Mobile drawer accordions ---- */
  document.querySelectorAll('[data-tmws-acc]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var panel = btn.nextElementSibling;
      if (!panel) return;
      var isOpen = btn.getAttribute('aria-expanded') === 'true';
      // one section open at a time keeps the drawer short enough to scan
      document.querySelectorAll('[data-tmws-acc]').forEach(function (b) {
        if (b !== btn) {
          b.setAttribute('aria-expanded', 'false');
          if (b.nextElementSibling) b.nextElementSibling.hidden = true;
        }
      });
      btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      panel.hidden = isOpen;
    });
  });

  /* ---- Mobile nav drawer ---- */
  var burger = document.querySelector('[data-tmws-burger]');
  var drawer = document.querySelector('[data-tmws-drawer]');
  if (burger && drawer) {
    burger.addEventListener('click', function () {
      var openNow = drawer.getAttribute('data-open') === 'true';
      drawer.setAttribute('data-open', openNow ? 'false' : 'true');
      drawer.style.display = openNow ? 'none' : 'block';
      burger.setAttribute('aria-expanded', openNow ? 'false' : 'true');
    });
  }
})();
